// POC: only the event ingestion hosts (US and EU). Other Amplitude hosts (CDN scripts, Session Replay,
// Experiment) are neither reported nor blocked.
const AMPLITUDE_INGESTION_HOSTS = [
  'api2.amplitude.com',
  'api.eu.amplitude.com',
];

// Relative URLs resolve to the page's own host, never Amplitude, so they fail to parse and return false.
export const isAmplitudeUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return AMPLITUDE_INGESTION_HOSTS.includes(hostname);
  } catch {
    return false;
  }
};
